import type {ReactElement} from 'react';
import React, {useState, useEffect} from 'react';
import type {AiChatHotjarFeedbackSurveyProps} from '@/ai-chat/components/ai-chat-hotjar-feedback-survey/ai-chat-hotjar-feedback-survey.types';
import {FeedbackButton} from '@Components/feedback-button';
import styles from './ai-chat-hotjar-feedback-survey.module.scss';
import {useAiChat} from '@/ai-chat/providers/ai-chat.context';

export function AiChatHotjarFeedbackSurvey({containerRef}: AiChatHotjarFeedbackSurveyProps): ReactElement | null {
  const {state: aiChatState} = useAiChat();
  const [chatWindowWidth, setChatWindowWidth] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (!containerRef.current) return;

    setChatWindowWidth(containerRef.current.getBoundingClientRect().width);

    const resizeObserver = new ResizeObserver((entries) => {
      requestAnimationFrame(() => {
        if (entries[0]) {
          setChatWindowWidth(entries[0].contentRect.width);
        }
      });
    });

    resizeObserver.observe(containerRef.current);

    return (): void => {
      resizeObserver.disconnect();
    };
  }, [containerRef]);


  if (chatWindowWidth === undefined || chatWindowWidth < 1042) {
    return null;
  }

  if (aiChatState.chatHistory.length === 0) {
    return null;
  }

  const getFeedbackButton = (): ReactElement | null => {
    let btnText: string;

    if (chatWindowWidth <= 1300) {
      btnText = window.i18next.t('pmwjs_feedback');
    } else {
      btnText = window.i18next.t('pmwjs_help_us_improve');
    }

    return (
      <FeedbackButton
        id={'ai-chat-feedback'}
        uriToShowSurveyButton={'ai/shouldShowAiChatFeedbackSurvey'}
        uriToMarkSurveyAsCompleted={'ai/markAiChatFeedbackSurveyAsCompleted'}
        btnText={btnText}
        floatingFeedbackButtonProps={{bottom: 8, right: 8}}
        btnCustomCLasses={styles.feedbackButton}
      />
    );
  };

  return getFeedbackButton();
}
